module.exports = __webpack_public_path__ + "media/images/icons/cart-9b685b21b24aa05d7c575e2cd8d50b97.svg";